import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import LoginPage from './pages/LoginPage';
import ServerSelectPage from './pages/ServerSelectPage';
import DashboardWrapper from './pages/DashboardWrapper';
import ApplyPage from './pages/ApplyPage';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--gradient-hero)',
      fontFamily: 'var(--font-body)',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🕐</div>
        <div style={{ color: 'var(--text-secondary)', fontSize: '16px' }}>Loading...</div>
      </div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}


function AuthCallback() {
  const { loadUser } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
      localStorage.setItem('brazyy_token', token);
      window.history.replaceState({}, '', '/auth');
    }
    loadUser().then(() => navigate('/servers', { replace: true }));
  }, []);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--gradient-hero)',
      fontFamily: 'var(--font-body)',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🕐</div>
        <div style={{ color: 'var(--text-secondary)' }}>Logging you in...</div>
      </div>
    </div>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth" element={<AuthCallback />} />
      <Route path="/servers" element={
        <ProtectedRoute><ServerSelectPage /></ProtectedRoute>
      } />
      <Route path="/dashboard/:guildId/*" element={
        <ProtectedRoute><DashboardWrapper /></ProtectedRoute>
      } />
      <Route path="/apply/:guildId" element={<ApplyPage />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
